import React, { useState, useEffect, useRef } from "react";
import { format, parseISO } from "date-fns";
import { getConfig } from "../helpers/auth-helper";
import { getSrcPath } from "../helpers/auth-helper";
import client from "../contentfulClient";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
let process = {
  env: {}
};
const SponsorList = () => {
  var _posts$fields, _posts$fields2;
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    const fetchPostById = async () => {
      try {
        const entry = await client.getEntry("7hIYI7reMEkTvCp1G1AKCz");
        const resolveLinks = async fields => {
          const resolvedFields = {
            ...fields
          };
          for (const key in fields) {
            const field = fields[key];
            if (Array.isArray(field)) {
              resolvedFields[key] = await Promise.all(field.map(async item => {
                if (item.sys && item.sys.type === "Link") {
                  return await client.getAsset(item.sys.id);
                }
                return item;
              }));
            } else if (field.sys && field.sys.type === "Link") {
              if (field.sys.linkType === "Asset") {
                resolvedFields[key] = await client.getAsset(field.sys.id);
              } else if (field.sys.linkType === "Entry") {
                resolvedFields[key] = await client.getEntry(field.sys.id);
              }
            }
          }
          return resolvedFields;
        };
        const resolvedFields = await resolveLinks(entry.fields);
        setPosts({
          ...entry,
          fields: resolvedFields
        });
        setTimeout(() => {
          console.log(posts);
        }, 5000);
      } catch (error) {
        console.error("Error fetching the post:", error);
      }
    };
    fetchPostById();
  }, []);
  function pageTitleFunc(pageTitle) {
    if (pageTitle != undefined) {
      const pageTitleVar = pageTitle.replace(/\*\*(.*?)\*\*/, "&nbsp;<p>$1</p>&nbsp;");
      return pageTitleVar;
    }
  }
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "sponsor-list-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields = posts.fields) === null || _posts$fields === void 0 ? void 0 : _posts$fields.headerText)
    }
  }), /*#__PURE__*/React.createElement("img", {
    style: {
      textAlign: "center",
      paddingBottom: "80px"
    },
    src: posts === null || posts === void 0 || (_posts$fields2 = posts.fields) === null || _posts$fields2 === void 0 || (_posts$fields2 = _posts$fields2.prizeImages[0]) === null || _posts$fields2 === void 0 || (_posts$fields2 = _posts$fields2.fields) === null || _posts$fields2 === void 0 || (_posts$fields2 = _posts$fields2.file) === null || _posts$fields2 === void 0 ? void 0 : _posts$fields2.url
  })));
};
export { SponsorList };